<div class="demooz_input"
    [class.no_margin]="this.noMargin"
    [class.disabled]="this.disabled"
    [class.text_left]="this.textAlign === 'left'"
    [class.text_center]="this.textAlign === 'center'"
    [class.text_right]="this.textAlign === 'right'"
    >
    
    @if(this.iconInput !== ''){
        <ion-icon class="demooz_input_icon_prefix" [name]="this.iconInput"></ion-icon>
    }
    
    @if(this.isRequired){
        <div class="demooz_input_required">*</div>
    }
    
    @if(this.fixedLabel){
        <div class="demooz_input_fixed_label" (click)="this.focusInput()">{{this.labelInput}}</div>
    }
    
    <input 
        #demoozInput
        [type]="this.typeInput" 
        [placeholder]="(!this.fixedLabel ? this.labelInput : '')" 
        [name]="this.formName" 
        [formControlName]="this.formName"       
        [autocomplete]="(this.autocomplete ? 'on' : 'off')"
        [min]="this.min"
        [max]="this.max"
        (focus)="this.onFocusInput.emit()"
        (blur)="this.onBlurInput.emit()"
        />    
    
    @if(this.originalTypeInput === 'password'){
        @if(this.showPassword){
            <ion-icon class="demooz_input_icon_sufix" name="eye-off-outline" (click)="this.togglePassword()"></ion-icon>
        }
        @else{
            <ion-icon class="demooz_input_icon_sufix" name="eye-outline" (click)="this.togglePassword()"></ion-icon>
        }        
    }
    @else{
    
        @if(this.showBtnClearInput 
            && this.formGroupDirective.form.controls[this.formName] 
            && this.formGroupDirective.form.controls[this.formName].value 
            && this.formGroupDirective.form.controls[this.formName].value != '' ){
            <ion-icon class="demooz_input_icon_sufix" name="close-circle-outline" (click)="this.clearInput()"></ion-icon>
        }
    }
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="demooz_input_error">{{this.errorText}}</div>
}
